import { render } from "./ModelCard.vue?vue&type=template&id=124bf98d&scoped=true"
import script from "./ModelCard.vue?vue&type=script&lang=js"
export * from "./ModelCard.vue?vue&type=script&lang=js"

import "./ModelCard.vue?vue&type=style&index=0&id=124bf98d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124bf98d"]])

export default __exports__